import {
    add,
    compose,
    endsWith,
    reduce,
    pick,
    values,
    keyBy,
    map,
    sumBy,
    get,
    meanBy,
    first,
    filter,
    keys,
    update,
    isString,
} from 'lodash/fp';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { normalizeSearchValue } from '@mews-commander/utils';
import { SelectProps } from '@optimus-web/core';
import { MIN_RATE_SUFFIX, MAX_RATE_SUFFIX } from '../constants';
import { existsDateRangeCollision } from './dates';
import { createDateRangeKey, getDateRangeFromKey } from './keys';

export const getExistingRateId = (rateId: $TSFixMe) => {
    if (endsWith(MIN_RATE_SUFFIX, rateId) || endsWith(MAX_RATE_SUFFIX, rateId)) {
        return rateId.substring(0, rateId.length - 4);
    }
    return rateId;
};

export const getMaxPersonCount = compose(reduce(add, 0), values, pick(['capacity', 'extraCapacity']));

export const processCategoryAvailabilities = (collidingReservations: $TSFixMe, isMultiTaxEnvironment: $TSFixMe) =>
    compose(
        keyBy('categoryId'),
        map(({ categoryId, availability, defaultPrices }) => ({
            categoryId,
            remainingCount: availability - compose(sumBy('count'), get(categoryId))(collidingReservations),
            selectedCount: 1,
            price: {
                value: meanBy(isMultiTaxEnvironment ? 'netValue' : 'value')(defaultPrices),
                currency: compose(get('currency'), first)(defaultPrices),
            },
        }))
    );

const getCategoryAvailabiltyDateRanges = (serviceId: $TSFixMe) =>
    compose(map(getDateRangeFromKey), keys, get([serviceId, 'categories']));
const createPath = (serviceId: $TSFixMe, categoryId: $TSFixMe) => (dateRange: $TSFixMe) => [
    serviceId,
    'categories',
    createDateRangeKey(dateRange),
    categoryId,
];
const updateCategoryAvailability =
    (path: $TSFixMe, updateStrategy: $TSFixMe) => (accumulator: $TSFixMe, dateRange: $TSFixMe) =>
        update(path(dateRange), updateStrategy, accumulator);

export const getUpdatedCategoryAvailabilities =
    (updateStrategy: $TSFixMe) =>
    (
        availabilityState: $TSFixMe,
        { serviceId, reservation: { categoryId, startDate, endDate, startTime, endTime }, count }: $TSFixMe
    ) => {
        const path = createPath(serviceId, categoryId);
        const updateAvailabilityCount = updateStrategy(count);
        return compose(
            reduce(updateCategoryAvailability(path, updateAvailabilityCount), availabilityState),
            filter(existsDateRangeCollision({ startDate, endDate, startTime, endTime })),
            getCategoryAvailabiltyDateRanges(serviceId)
        )(availabilityState);
    };

export const reservationPlaceSearchValueMapper: SelectProps['searchValueMapper'] = ({
    props: { label, description },
}) => {
    const primary = isString(label) ? normalizeSearchValue(label) : '';
    const secondary = isString(description) ? normalizeSearchValue(description) : '';

    return `${primary}${'__'}${secondary}`;
};

export const localizeWithoutSymbol = (currencyObj: $TSFixMe) => {
    const container = getContainer();
    const { appLocalizationComponent } = container();

    return appLocalizationComponent.localizeCurrencyValue(currencyObj, { showSymbol: false });
};

export const getCurrencyValue = pick(['value', 'currency']);

export const getNetValueCurrency = (priceObject: $TSFixMe) => ({
    value: priceObject.netValue,
    currency: priceObject.currency,
});

export const getBeforeNetValueCurrency = (priceObject: $TSFixMe) =>
    priceObject.before
        ? {
              value: get(['before', 'netValue'], priceObject),
              currency: get(['before', 'currency'], priceObject),
          }
        : null;
